import React from 'react';
import ViewContainer from './viewContainer';

/**
 * Componente de landing page
 * @author Jhoan López <jhoanlt19@gmail.com>
 */
class LandingPage extends React.Component{

    render(){
        return(
            <ViewContainer/>
        )
    }
}

export default LandingPage;


// WEBPACK FOOTER //
// ./src/components/landing-page/index.js